import { render, staticRenderFns } from "./SolutionMain.vue?vue&type=template&id=35ff2ca8&"
import script from "./SolutionMain.vue?vue&type=script&lang=js&"
export * from "./SolutionMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports